import React from 'react';
import clsx from 'clsx';
import lazy from 'common/utils/lazy';
import { makeStyles } from '@material-ui/core/styles';
import ThemeProvider from 'components/v2/ThemeProvider';
import { routes } from 'routes';

const SideBar = lazy(() => import('./SideBar'), { chunkName: 'SideBar' });
const AppBar = lazy(() => import('./AppBar/index'), { chunkName: 'AppBar' });

const useWrappedPageStyles = makeStyles(
  {
    wrapper: {
      display: 'grid',
      gridTemplateColumns: 'auto minmax(0, 1fr)',
      gridTemplateRows: '60px auto',
      gridTemplateAreas: `
        'sidebar appbar'
        'sidebar pageContent'
      `,
      height: '100%',
      backgroundColor: '#f7f4f1',
      flex: 1,
    },
    appBar: {
      gridArea: 'appbar',
    },
    sideBar: {
      gridArea: 'sidebar',
      overflow: 'hidden',
    },
    pageContent: {
      gidArea: 'pageContent',
      overflow: 'auto',
      position: 'relative',
    },
  },
  { name: `${__filename}.wrappedPage` },
);

const WrappedPageInner = ({ page: Page, ...props }) => {
  const classes = useWrappedPageStyles();
  return (
    <div className={clsx(classes.wrapper)}>
      <div className={classes.sideBar}>
        <SideBar routes={routes} />
      </div>
      <div className={classes.appBar}>
        <AppBar />
      </div>
      <div className={classes.pageContent}>
        <Page {...props} />
      </div>
    </div>
  );
};

export default function WrappedPage(props) {
  return (
    <ThemeProvider>
      <WrappedPageInner {...props} />
    </ThemeProvider>
  );
}
